import React from 'react';

const formatDate = (iso) => {
  if (!iso) return 'Not specified';
  const date = new Date(iso);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

const GradeTooltip = ({ grade, position, visible }) => {
  if (!visible || !grade) return null;

  return (
    <div
      className="fixed z-50 pointer-events-none"
      style={{
        left: position.x + 10,
        top: position.y - 10,
      }}
    >
      <div className="bg-grey-dusk text-white text-sm rounded-lg shadow-brand-lg p-3 max-w-xs">
        <div className="space-y-1">
          <div className="font-semibold">Grade: {grade.gradeValue}</div>
          <div>Weight: {grade.weight || 1.0}</div>
          <div>Date: {formatDate(grade.examDate)}</div>
          {grade.description && grade.description.trim() !== '' && (
            <div className="border-t border-pale-dawn/30 pt-1 mt-2">
              <div className="text-pale-dawn/80">Description:</div>
              <div>{grade.description || 'No description'}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GradeTooltip;